import {
  ERPSeedless,
  ERPRJL
} from "src/utils/constants";
import { IRoute } from "src/pages/Router/routes";
import { Icons } from "src/library/components/Icon/types";

import ListOrdersPage from "./ListOrdersPage";
import ViewListPage from "./ViewListPage";

export const CustomerLists: IRoute[] = [
  {
    exact: true,
    path: "/lists/:listId",
    pageComponent: ViewListPage,
    title: "%LIST% Details",
    allowedContexts: [ "LIST_PRODUCT_SELECTION" ],
    contextMenu: {
      LIST_PRODUCT_SELECTION: {
        hidden: false,
        icon: Icons.CART,
        title: "%CART%"
      }
    },
    menuType: "MAIN",
    roles: [ "customer" ],
    hidden: true,
    privateRoute: true
  },
  {
    exact: true,
    path: "/lists/:listId",
    pageComponent: ViewListPage,
    title: "%LIST% Details",
    menuType: "ADMIN_MAIN",
    contextMenu: {
      LIST_PRODUCT_SELECTION: {
        hidden: false,
        icon: Icons.CART,
        title: "%CART%"
      }
    },
    roles: [ "admin" ],
    allowedContexts: [ "LIST_PRODUCT_SELECTION" ],
    privateRoute: true,
    hidden: true
  },
  {
    exact: true,
    path: "/lists/:listId/orders",
    pageComponent: ListOrdersPage,
    title: "%LIST% %ORDERS%",
    menuType: "MAIN",
    roles: [ "customer" ],
    hidden: true,
    privateRoute: true
  },
  {
    exact: true,
    path: "/lists/:listId/orders",
    pageComponent: ListOrdersPage,
    title: "%LIST% %ORDERS%",
    menuType: "ADMIN_MAIN",
    allowedContexts: [ "LIST_PRODUCT_SELECTION" ],
    roles: [ "admin" ],
    hidden: true,
    privateRoute: true
  }
];

export default CustomerLists;
